import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Info, Actions, Toast, API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/FormImports';
import { Payout } from 'models/PayoutModel';


const PayoutForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.PAYOUT, Code.Form.Name.PAYOUT];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [segmentOptions, setSegmentOptions] = Hooks.Form.Options();
  const [mopOptions, setMopOptions] = Hooks.Form.Options();
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [statusOptions, setStatusOptions] = Hooks.Form.Options();
  const [bankOptions, setBankOptions] = Hooks.Form.Options();
  const [payeeOptions, setPayeeOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Payout>({});
  const [userOptions, setUserOptions] = Hooks.Form.Options();

  const userId = Utility.Storage.UserId();
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const RoleSpecial = Hooks.Privilege.RoleSpecial();
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.API(Code.File.SEGMENT, Code.Option.Common.SELECT, setSegmentOptions, setError);
    Files.Json.API(Code.File.Payee, Code.Option.Common.SELECT, setPayeeOptions, setError);
    Files.Json.API(Code.File.MOP, Code.Option.Common.SELECT, setMopOptions, setError);
    Files.Json.API(Code.File.BANK, Code.Option.Common.NA, setBankOptions, setError);
    Files.Json.API(Code.File.OPTION+Code.Group.PAYOUT_TYPE, Code.Option.Common.SELECT, setTypeOptions, setError, true);
    Files.Json.API(Code.File.OPTION+Code.Group.PAYOUT_STATUS, Code.Option.Common.NA, setStatusOptions, setError);
    Files.Json.API(Code.File.USER, Code.Option.Common.SELECT, setUserOptions, setError);
   
    API.Data.GetByKeyId<Payout>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.payout_active); 
        const formData = await Form.Map.Data(data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
        setLoading(false);
      }})
     
      const onNewEntry = async () => {
        if(keyId===Code.Key.NEW) {
        setFormData((prev) => ({
          ...prev, 
          user_id: userId,
          segment_id: Code.Option.Segment.OPTICAL,
        }));
        }
        setLoading(false);
      };
      onNewEntry();

      
  }, []);

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      payout_amount: formData.type_id == 90 ? -Math.abs(formData.payout_amount || 0) : Math.abs(formData.payout_amount || 0)
    });

    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Payout Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
            
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Date id={Name.Payout.Date} value={formData.payout_date} title={Title.Date} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,33,1]} require={true} currentDate={true} />
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Type} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,34,1]} require={true} />
                <Field.FilterSelect id={Name.User.Id} value={formData.user_id} title={Title.Dispenser} options={userOptions} setFormData={setFormData} size={[1,33,0]} require={true} disabled={!RoleSpecial.includes(Code.RoleSpecial.ENABLE_DISPENSER_NAME)} />
              </Control.Row>
              <Control.Row>
                <Field.FilterSelect id={Name.Payee.Id} value={formData.payee_id} title={Title.Payee} options={payeeOptions} setFormData={setFormData} require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Amount id={Name.Payout.Amount} value={formData.payout_amount} title={Title.Amount} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
                <Field.FilterSelect id={Name.Common.ModeId} value={formData.mode_id} title={Title.MOP} options={mopOptions} setFormData={setFormData} size={[1,50,0]}  require={true} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.StatusId} value={formData.status_id} title={Title.Status} options={statusOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} />
                <Field.Select id={Name.Bank.Id} value={formData.bank_id} title={Title.Bank} options={bankOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)}  size={[1,50,0]} />
              </Control.Row>
              <Control.Row>
                <Field.Area id={Name.Payout.Comment} value={formData.payout_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Row>
              <Control.Row>
                <Field.Select id={Name.Common.SegmentId} value={formData.segment_id} title={Title.Segment} options={segmentOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} selected={Code.Option.Segment.OPTICAL} />
                <Field.Text id={Name.Common.RefNo} value={formData.payout_ref_number} title={Title.Refno} onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,50,0]} />
              </Control.Row>
            </Control.Tab.Content>
          
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default PayoutForm;